export interface VehicleEligibility {
  isEligible: boolean;
  excludedEngines: number[];
  excludedDrivetrains: number[];
  excludedTransmissions: number[];
}

export interface YearRange {
  min: number;
  max: number;
}

export const fetchVehicleEligibility = async (trimId: number): Promise<VehicleEligibility> => {
  if (!trimId) {
    throw 'trimId is required';
  }

  const url = `${process.env.EDGE_URL}/${process.env.V_PREFIX}/vehicles/eligibility`;
  const parms = new URLSearchParams({
    trimId: trimId.toString(),
    a: 'b',
    api_key: process.env.API_KEY,
  });

  const resp = await fetch(`${url}?${parms}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      'Content-Type': 'text/json',
    },
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
  });

  if (resp.ok) {
    const retVal = mapResponseToRecord(await resp.json());

    return retVal;
  }
  throw `Error getting data for trimId ${trimId} response status ${resp.status}`;
};

export const fetchYearsEligibility = async (): Promise<YearRange> => {
  const url = `${process.env.EDGE_URL}/${process.env.V_PREFIX}/vehicles/years?a=b&api_key=${process.env.API_KEY}`;
  const resp = await fetch(url, {
    headers: {
      referer: `${process.env.EDGE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  });

  if (resp.ok) {
    const retVal = await resp.json();

    const years = retVal.data.map((x) => {
      return x.yearId;
    });

    const yearRange: YearRange = {
      min: Math.min(...years),
      max: Math.max(...years),
    };

    return yearRange;
  }
  throw `Error when getting Years Eligibility for Dynamic Entry. Response status ${resp.status}`;
};

const mapResponseToRecord = (rawResponse): VehicleEligibility => {
  const eligibilityRec: VehicleEligibility = rawResponse.data;
  return eligibilityRec;
};
